export enum CategoriaEdital {
    ALUNO_TECNICO = 'ALUNO_TECNICO',
    ALUNO_GRADUACAO = 'ALUNO_GRADUACAO',
    ALUNO_POS = 'ALUNO_POS',
    SERVIDOR = 'SERVIDOR',
    PROCURADOR = 'PROCURADOR',
    DOCENTE = 'DOCENTE'
}

const categoriaLabels: Record<CategoriaEdital, string> = {
    [CategoriaEdital.ALUNO_TECNICO]: 'Aluno Técnico',
    [CategoriaEdital.ALUNO_GRADUACAO]: 'Aluno Graduação',
    [CategoriaEdital.ALUNO_POS]: 'Aluno Pós-graduação',
    [CategoriaEdital.SERVIDOR]: 'Servidor',
    [CategoriaEdital.PROCURADOR]: 'Procurador',
    [CategoriaEdital.DOCENTE]: 'Docente'
};

export const formatarCategoria = (categoria?: CategoriaEdital | null): string => {
    if (!categoria) {
        return 'Categoria não informada';
    }
    return categoriaLabels[categoria] ?? categoria;
};
